import { createApp } from 'vue'
import App from './App.vue'
import routes from './router'
import Antd from 'ant-design-vue';
import {createRouter, createWebHistory} from 'vue-router';
import store from './store/store';
import 'ant-design-vue/dist/antd.css';
import { useRoute } from 'vue-router';

// Vue.use(Antd);

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

function getUrlParams(url) {
  var params = {};
  url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) { params[key] = value; });
  return params;
}

function setCookie(cookie_name, value, days) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + days);
  // 설정 일수만큼 현재시간에 만료값으로 지정

  var cookie_value = escape(value) + ((days == null) ? '' : ';    expires=' + exdate.toUTCString());
  document.cookie = cookie_name + '=' + cookie_value;
}

router.beforeEach(async (to, from, next) => {
  const query = getUrlParams(window.location.href);
  const { token } = query;
  if(token)
    setCookie('token', token, 30);
  next();
});

createApp(App).use(router).use(store).mount('#app')